var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:["n-checkbox", _vm.disabled && 'disabled']},[_c('input',{attrs:{"id":("" + _vm.id),"type":"checkbox","readonly":_vm.readonly,"disabled":_vm.disabled},domProps:{"checked":_vm.value},on:{"change":_vm.onChange}}),_vm._v(" "),_c('label',{attrs:{"for":_vm.id}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.label)}}),_vm._v(" "),_vm._t("default")],2)])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-283a0fa2","hasScoped":false,"optionsId":"27","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/n-checkbox.vue
// module id = siak
// module chunks = 0